export default "__VITE_ASSET__C8Ywi_dJ__"